import axios from 'axios';
import { getOrganizationSettings } from './utils/storage';
import { isValidEmail } from './utils/utils';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';


// Request password reset token
export async function requestPasswordResetToken(username) {

  const newOrg = getOrganizationSettings();

  const appid = newOrg.id;

  var payload = {};

  if (isValidEmail(username)) {
    payload = { email: username };
  } else if (username.length == 10) {
    payload = { AccNumber: username };
  } else {
    payload = { Telephone: username };
  }

  console.log(payload);


  const response = await axios.post(
    `${API_BASE_URL}password/request-token`,
    payload,
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AppID': appid,
      }
    }
  );

  console.log(response, "Server response");

  return response.data;
}

// Verify password reset token
export async function verifyPasswordResetToken(username, token) {

  const newOrg = getOrganizationSettings();

  var payload;

  if (isValidEmail(username)) {
    payload = { email: username };
  } else if (username.length == 10) {
    payload = { AccNumber: username };
  } else {
    payload = { Telephone: username };
  }
 
  payload = {...payload, token}

  
  console.log(payload);
  

  const appid = newOrg.id;
  const response = await axios.post(
    `${API_BASE_URL}password/verify-token`,
    payload,
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AppID': appid,
      }
    }
  );
  return response.data;
}

// Reset password
export async function resetPassword(username, token, password, password_confirmation) {

  const newOrg = getOrganizationSettings();

  var payload = {};


  if (isValidEmail(username)) {
    payload = { email: username };
  } else if (username.length == 10) {
    payload = { AccNumber: username };
  } else {
    payload = { Telephone: username };
  }

  payload = { ...payload, token, password, password_confirmation }

  const appid = newOrg.id;
  const response = await axios.post(
    `${API_BASE_URL}password/reset`,
    payload,
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AppID': appid,
      }
    }
  );
  return response.data;
} 